import React from 'react';
import styled from 'styled-components';

const StyledTitle = styled.h1`
  font-family: 'Runtoe', 'Pacifico', 'Dancing Script', cursive;
  font-weight: normal;
  font-size: 4rem;
  color: #eee;
  margin: 1.6rem 0;
  /* text-transform: capitalize; */
  /* text-decoration: underline; */
  text-align: ${props => props.align ? props.align : 'left'};
  @media screen and (max-width: 768px) {
    font-size: 2.4rem;  /* Adjust font size for smaller screens */
  }
`;

export const SubTitle= styled.p`
  /* font-family: 'Raleway', cursive; */
  font-size: 1.6rem;
  color: #ddd;
  margin: 0.5rem 0 0.3rem 0;
`;

export function Title({ children, align }) {
    return (
        <StyledTitle align={align}>{children}</StyledTitle>
    )
}
